// extracted by mini-css-extract-plugin
module.exports = {"FormBenefitsBoxWrapper":"FormBenefits_FormBenefitsBoxWrapper__6Qrf3","errorMsg":"FormBenefits_errorMsg__17r2Z"};